export default __webpack_public_path__ + "static/media/sort-icon.15b04498.svg";